import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquibutton',
	templateUrl:'./JQUIButtonPage.html',
	styles: [],
	styleUrls:['./JQUIButtonPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUIButtonPage
{
	mdContent_184 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.button.JQUIButton;
\`\`\``;
	mdContent_185 = `\`\`\`java
new JQUIButton&lt;&gt;()
\`\`\``;
	mdContent_186 = `\`\`\`java
new JQUIButton&lt;&gt;(String text)
\`\`\``;
	mdContent_187 = `\`\`\`java
var btn = new JQUIButton<>("Save");
btn.getOptions().setIcons(new JQUIButtonIcon("ui-icon-disk"));
\`\`\``;
}
